// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useCallback, useEffect, useReducer, useRef, useState } from 'react'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { debounce, Dropdown, PageLoadingSpinner, Search, useSessionStorage, useUpdateEffect } from 'ui_kit_qmd'
import { findIana } from 'windows-iana'
import moment from 'moment-timezone'
import { useSearchParams } from 'react-router-dom'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { addListener } from '@reduxjs/toolkit'
import { ErrorAlert } from '../../components/ui_kit_quickMD/error-alert/erroralert'
import errorIcon from '../../images/common/error-icon.svg'
import {
  PAST_VISIT,
  PATIENT_PAST_VISIT_ROUTE,
  tableViewOptions,
  UPCOMING_VISIT,
  VISITS_CALENDAR_ROUTE,
  VISITS_LABEL,
  VISITS_STATUS_FILTER_LOCAL_STORAGE_KEY,
  VISITS_TAG_FILTER_LOCAL_STORAGE_KEY,
  VISITS_VISIT_FILTER_LOCAL_STORAGE_KEY,
} from '../../utils/constants'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS } from '../../store/file-pop-up/FilePopUpConstants'
import {
  cancelVisitFromVisitsPage,
  changeVisitStatus,
  getVisits,
  setIsVisitStatusChangedSuccess,
  setVisitError,
} from '../../store/visits/VisitsActions'
import { VisitsTable } from './VisitsTable'
import './Visits.scss'
import { initialState, reducer, updateTimeZone } from './VisitsReducer'
import { eventEmitter } from '../../middlewares/SuccessEventEmitterMiddleware'
import { Pagination } from '../../components/pagination/Pagination'
import { getVisitSearchParams, onHandleLinkToCalendar, onHandleLinkToVisit, getFilterRowAPI } from './VisitTools'
import { CancelVisitPopup } from '../../components/CancelVisitPopup/CancelVisitPopup'
import { isAsynchronousVisitMethod } from '../../utils/getVisitTypeLabel'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { routeParam, text, visitTableView, searchDropdownOptions, filterRowTypeAPI } from './constants'
import { ResolveVisitPopUp } from './resloveVisitPopUp/ResolveVisitPopUp'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { getTabId } from '../../utils/common'
import { useChangeSearchParams } from '../../utils/useChangeSearchParams'
import { TIME_FOR_DATE_RANGE_REQUEST_FROM, TIME_FOR_DATE_RANGE_REQUEST_TO } from '../../utils/dateUtils'
import { VisitsListener } from './VisitsListener'

const selectVisitTypeDropdownContainerStyle = {
  width: 155,
  height: 40,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  border: '1px solid #C2D5E2',
  borderStyle: 'solid',
  background: '#FFFFFF',
  marginLeft: 0,
  paddingLeft: 0,
}
const selectVisitTypeDropdownListContainerStyle = {
  width: 154,
  marginTop: 6,
  height: 88,
}
const selectVisitTypeDropdownIconStyle = {
  top: 12,
  right: 13,
}
const selectVisitTypeDropdownInputStyle = {
  padding: 0,
  margin: '0px 0px 0px 10px',
  height: 28,
  width: 90,
}

const COUNT_STEP = 9
const PAGINATION_INITIAL = [0, COUNT_STEP, false]

const Visits = () => {
  const tabId = getTabId()
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const { onChangeSearchParam } = useChangeSearchParams()

  const {
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    initialSearchValue,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    initialVisitsMode,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    initialDateRange,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    activeFlags,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    initialTagsFilter,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    initialDrugScreenStatuses,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    initialIdentityVerificationStatuses,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    initialStatusFilter,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    initialVisitTypes,
  } = getVisitSearchParams()

  // Account settings reducer
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const profile = useSelector((state) => state.accountSettings.adminProfile)

  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
  const dateFilterOffStateValue = initialState({
    timeZone: profile.TimeZone ? findIana(profile.TimeZone)[0] : null,
  })

  // Visit reducer
  const { error, loading, visits, isVisitStatusChangedSuccess, changeVisitStatusData } = useSelector((state) => ({
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    error: state.visitsReducer.error,
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    loading: state.visitsReducer.loading,
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    visits: state.visitsReducer.visits,
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    isVisitStatusChangedSuccess: state.visitsReducer.isVisitStatusChangedSuccess,
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    visitData: state.visitsReducer.visitData,
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    changeVisitStatusData: state.visitsReducer.changeVisitStatusData,
  }))

  const [stateFilter, dispatchFilter] = useReducer(
    reducer,
    initialState({
      timeZone: profile.TimeZone ? findIana(profile.TimeZone)[0] : null,
      dateFrom: initialDateRange?.from,
      dateTo: initialDateRange?.to,
    }),
  )

  const { visitsList, totalCount } = visits
  const [visitsMode, setVisitsMode] = useState(initialVisitsMode)
  const [showRemarks, setShowRemarks] = useState(false)

  const [defaultVisitSearchValue, setDefaultVisitSearchValue] = useState(initialSearchValue)
  const [visitSearchValue, setVisitSearchValue] = useState(initialSearchValue)
  const [visitTypesFilterRow, setVisitTypesFilterRow] = useState(
    initialVisitTypes ? getFilterRowAPI(filterRowTypeAPI.VISIT_TYPES_IDS, initialVisitTypes) : '',
  )
  const [statusFilterRow, setStatusFilterRow] = useState(
    initialStatusFilter ? getFilterRowAPI(filterRowTypeAPI.STATUSES, initialStatusFilter) : '',
  )
  const [tagFilterRow, setStatusTagRow] = useState(
    initialTagsFilter ? getFilterRowAPI(filterRowTypeAPI.TAGS, initialTagsFilter) : '',
  )
  const [drugScreenStatusesFilterRow, setDrugScreenStatusesFilterRow] = useState(
    initialDrugScreenStatuses ? getFilterRowAPI(filterRowTypeAPI.DRUG_SCREEN_STATUSES, initialDrugScreenStatuses) : '',
  )
  const [identityVerificationStatusesFilterRow, setIdentityVerificationStatusesFilterRow] = useState(
    initialIdentityVerificationStatuses ?
      getFilterRowAPI(filterRowTypeAPI.IDENTITY_VERIFICATION_STATUSES, initialIdentityVerificationStatuses)
    : '',
  )

  const [paginationState, setPaginationState] = useState(PAGINATION_INITIAL)
  const [isFirstRender, setIsFirstRender] = useState(true)
  const [isOpenCancelPopup, setIsOpenCancelPopup] = useState(false)
  const [isOpenResolvePopup, setIsOpenResolvePopup] = useState(false)
  const [triggerTabId, setTriggerTabId] = useState('')
  const [isPopstateChanges, setIsPopstateChanges] = useState(false)
  const [isReloadSection, setIsReloadSeaction] = useState(false)
  const [selectedVisitId, setSelectedVisitId] = useState(null)
  const isUpcoming = visitsMode === visitTableView.UPCOMING

  const [, , removeStoredSelectedStatusList] = useSessionStorage(VISITS_STATUS_FILTER_LOCAL_STORAGE_KEY, [])
  const [, , removeStoredSelectedList] = useSessionStorage(VISITS_VISIT_FILTER_LOCAL_STORAGE_KEY, [])
  const [, , removeStoredSelectedTagsList] = useSessionStorage(VISITS_TAG_FILTER_LOCAL_STORAGE_KEY, [])

  const closeRemarks = useCallback(() => {
    setShowRemarks(false)
    eventEmitter.clear()
  }, [])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const reloadSection = (withSearchParams) => {
    const { fromDate, toDate } = dateFilterOffStateValue.date
    if (withSearchParams) {
      dispatch(
        getVisits({
          fromDate: initialDateRange?.from ?? fromDate,
          toDate: initialDateRange?.to ?? toDate,
          visitsMode,
          Offset: paginationState[0],
          Count: COUNT_STEP,
          searchValue: visitSearchValue,
          visitTypesFilterRow,
          statusFilterRow,
          tagFilterRow,
          drugScreenStatusesFilterRow,
          identityVerificationStatusesFilterRow,
          activeFlags,
        }),
      )
    } else {
      onChangeSearchParam()

      setVisitsMode(visitTableView.UPCOMING)
      setVisitSearchValue('')
      setDefaultVisitSearchValue('')
      setVisitTypesFilterRow('')
      setStatusFilterRow('')
      setStatusTagRow('')
      setDrugScreenStatusesFilterRow('')
      setIdentityVerificationStatusesFilterRow('')
      setIsReloadSeaction(true)

      dispatchFilter({
        type: 'date',
        payload: {
          fromDate,
          toDate,
          isDateUpdated: false,
        },
      })
      dispatch(
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        getVisits({
          fromDate,
          toDate,
          visitsMode: visitTableView.UPCOMING,
          Offset: paginationState[0],
          Count: COUNT_STEP,
          searchValue: '',
          visitTypesFilterRow: '',
          statusFilterRow: '',
          tagFilterRow: '',
          drugScreenStatusesFilterRow: '',
          identityVerificationStatusesFilterRow: '',
        }),
      )
    }
  }

  useEffect(() => {
    dispatch(changeVisitStatus({}))
    const handlePopState = () => {
      const { fromDate, toDate } = stateFilter.date

      const {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        initialSearchValue,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        initialVisitsMode,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        initialDateRange,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        initialStatusFilter,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        initialVisitTypes,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        initialTagsFilter,
      } = getVisitSearchParams()

      const getDateFromValue = () =>
        stateFilter.timeZone ?
          moment(initialDateRange.from)
            .parseZone()
            .tz(stateFilter.timeZone, true)
            .format(TIME_FOR_DATE_RANGE_REQUEST_FROM)
        : moment(initialDateRange.from).format(TIME_FOR_DATE_RANGE_REQUEST_FROM)

      const getToDateValue = () =>
        stateFilter.timeZone ?
          moment(initialDateRange.to).parseZone().tz(stateFilter.timeZone, true).format(TIME_FOR_DATE_RANGE_REQUEST_TO)
        : moment(initialDateRange.to).format(TIME_FOR_DATE_RANGE_REQUEST_TO)

      setIsPopstateChanges(true)
      setDefaultVisitSearchValue(initialSearchValue)
      setVisitSearchValue(initialSearchValue)
      setVisitsMode(initialVisitsMode)
      dispatchFilter({
        type: 'date',
        payload: {
          fromDate: initialDateRange ? getDateFromValue() : fromDate,
          toDate: initialDateRange ? getToDateValue() : toDate,
          isDateUpdated: !!initialDateRange,
        },
      })
      setStatusFilterRow(initialStatusFilter ? getFilterRowAPI(filterRowTypeAPI.STATUSES, initialStatusFilter) : '')
      setVisitTypesFilterRow(
        initialVisitTypes ? getFilterRowAPI(filterRowTypeAPI.VISIT_TYPES_IDS, initialVisitTypes) : '',
      )
      setStatusTagRow(initialTagsFilter ? getFilterRowAPI(filterRowTypeAPI.TAGS, initialTagsFilter) : '')
      setDrugScreenStatusesFilterRow(
        initialDrugScreenStatuses ?
          getFilterRowAPI(filterRowTypeAPI.DRUG_SCREEN_STATUSES, initialDrugScreenStatuses)
        : '',
      )
      setIdentityVerificationStatusesFilterRow(
        identityVerificationStatusesFilterRow ?
          getFilterRowAPI(filterRowTypeAPI.IDENTITY_VERIFICATION_STATUSES, initialIdentityVerificationStatuses)
        : '',
      )
    }

    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [])

  const fetchVisits = useCallback(() => {
    const { fromDate, toDate } = dateFilterOffStateValue.date

    dispatch(
      getVisits({
        fromDate: initialDateRange?.from ?? fromDate,
        toDate,
        visitsMode,
        Offset: paginationState[0],
        Count: 9,
        searchValue: visitSearchValue,
        visitTypesFilterRow,
        statusFilterRow,
        tagFilterRow,
        drugScreenStatusesFilterRow,
        identityVerificationStatusesFilterRow,
        activeFlags,
      }),
    )
  }, [
    dispatch,
    initialDateRange,
    visitsMode,
    paginationState,
    visitSearchValue,
    visitTypesFilterRow,
    statusFilterRow,
    tagFilterRow,
    drugScreenStatusesFilterRow,
    identityVerificationStatusesFilterRow,
    activeFlags,
  ])

  useEffect(() => {
    if (isPopstateChanges) {
      setIsPopstateChanges(false)
    }
  }, [isPopstateChanges])

  useEffect(() => {
    if (isReloadSection) {
      setIsReloadSeaction(false)
    }
  }, [isReloadSection])

  useEffect(() => {
    if (
      isVisitStatusChangedSuccess ||
      error === getUserFriendlyErrorMessage(errorCodes.CANNOT_CANCEL_VISIT) ||
      error === getUserFriendlyErrorMessage(errorCodes.CANNOT_RESHEDULE_VISIT)
    ) {
      closeRemarks()
      reloadSection(true)
      dispatch(setIsVisitStatusChangedSuccess())
    }
  }, [isVisitStatusChangedSuccess, error])

  useEffect(() => {
    const timeZoneToCheck = profile.TimeZone ? findIana(profile.TimeZone)[0] : null
    if (!isFirstRender && timeZoneToCheck !== stateFilter.timeZone) {
      dispatchFilter(updateTimeZone(stateFilter, timeZoneToCheck))
      closeRemarks()
    }
  }, [profile])

  useEffect(() => {
    if (changeVisitStatusData.visitId) {
      if (changeVisitStatusData.newStatus === text.RESOLVE_VISIT) {
        setIsOpenResolvePopup(true)
      } else {
        setIsOpenCancelPopup(true)
      }
    } else {
      setIsOpenResolvePopup(false)
      setIsOpenCancelPopup(false)
    }
  }, [changeVisitStatusData])

  useEffect(() => {
    if (selectedVisitId && triggerTabId === tabId) {
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const visitFullData = visits?.visitsList?.find((visit) => visit.VisitId === selectedVisitId) ?? []
      const { Provider, Status, VisitId, Patient } = visitFullData
      const isLinkToCalendar = UPCOMING_VISIT.includes(Status)
      const isLinkToPastVisit = PAST_VISIT.includes(Status)
      let link = ''

      if (isLinkToCalendar && Provider?.ProviderId) {
        onHandleLinkToCalendar({ VisitId, Provider, stateFilter })
        link = `${VISITS_CALENDAR_ROUTE}/${Provider.ProviderId}`
      }

      if (isLinkToPastVisit) {
        onHandleLinkToVisit({ VisitId, PatientId: Patient.PatientId, Provider })
        link = `${PATIENT_PAST_VISIT_ROUTE}/${VisitId}`
        if (isUpcoming) {
          closeRemarks()
          // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
          reloadSection()
        }
      }
      if (link) {
        window.open(link, '_blank', 'noopener noreferrer')
      }
      setSelectedVisitId(null)
      setTriggerTabId('')
    }
  }, [selectedVisitId])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onPagination = (forward) => {
    setPaginationState((prev) => {
      const isValid =
        forward ?
          Number(prev[0]) + COUNT_STEP < totalCount && prev[1] !== totalCount
        : Number(prev[0]) - COUNT_STEP >= 0

      if (isValid) {
        return isValid && forward ?
            [Number(prev[0]) + COUNT_STEP, Number(prev[1]) + COUNT_STEP, true]
            // @ts-expect-error TS2362 -- MIGRATION: not approved, fix when encountered
          : [prev[0] - COUNT_STEP, prev[1] - COUNT_STEP, true]
      }

      return prev
    })
  }

  const paginationLeft = () => {
    onPagination(false)
    if (showRemarks) {
      closeRemarks()
    }
  }
  const paginationRight = () => {
    onPagination(true)
    if (showRemarks) {
      closeRemarks()
    }
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onChangeTableView = (newTableView) => {
    const routeParamTableView = newTableView !== visitTableView.UPCOMING ? newTableView : null
    removeStoredSelectedStatusList()
    setStatusFilterRow('')
    setVisitsMode(newTableView)

    const searchParamsObj = Object.fromEntries(searchParams)
    delete searchParamsObj.visitStatus

    onChangeSearchParam({
      key: routeParam.VISIT_MODE,
      value: routeParamTableView,
      customSearchParams: searchParamsObj,
    })
  }

  const searchTitle = useRef('')

  useEffect(() => {
    removeStoredSelectedList()
    removeStoredSelectedStatusList()
    removeStoredSelectedTagsList()
    setIsFirstRender(false)
  }, [])

  useUpdateEffect(() => {
    if (paginationState[2]) {
      const { fromDate, toDate } = stateFilter.date
      dispatch(
        getVisits({
          fromDate,
          toDate,
          visitsMode,
          Offset: paginationState[0],
          Count: COUNT_STEP,
          searchValue: visitSearchValue,
          visitTypesFilterRow,
          statusFilterRow,
          tagFilterRow,
          drugScreenStatusesFilterRow,
          identityVerificationStatusesFilterRow,
          activeFlags,
        }),
      )
      searchTitle.current = visitSearchValue ?? ''
    }
  }, [paginationState])
  useEffect(() => {
    const { fromDate, toDate } = stateFilter.date

    if (!isFirstRender) {
      setPaginationState(PAGINATION_INITIAL)
    }

    if (!isReloadSection) {
      dispatch(
        getVisits({
          fromDate,
          toDate,
          visitsMode,
          Offset: PAGINATION_INITIAL[0],
          Count: COUNT_STEP,
          searchValue: visitSearchValue,
          visitTypesFilterRow,
          statusFilterRow,
          tagFilterRow,
          drugScreenStatusesFilterRow,
          identityVerificationStatusesFilterRow,
          activeFlags,
        }),
      )
    }

    searchTitle.current = visitSearchValue ?? ''
  }, [visitsMode, visitTypesFilterRow, statusFilterRow, stateFilter.date, tagFilterRow])

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        dispatch(setVisitError(''))
      }, 3500)
    }
  }, [error])

  useEffect(() => {
    if (stateFilter.error) {
      setTimeout(() => {
        dispatchFilter({ type: 'error', payload: '' })
      }, 3500)
    }
  }, [stateFilter.error])

  useEffect(() => {
    const { fromDate, toDate } = stateFilter.date

    if (visitSearchValue.length >= 3 && !isPopstateChanges) {
      setPaginationState(PAGINATION_INITIAL)

      const options = {
        visitsMode,
        fromDate,
        toDate,
        Offset: PAGINATION_INITIAL[0],
        Count: COUNT_STEP,
        searchValue: visitSearchValue,
        visitTypesFilterRow,
        statusFilterRow,
        tagFilterRow,
      }

      searchTitle.current = visitSearchValue ?? ''
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getVisits(options))
    }
  }, [])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onChangeSearchInput = (value) => {
    const { fromDate, toDate } = stateFilter.date
    setPaginationState(PAGINATION_INITIAL)
    const searchValue = value.trim()

    onChangeSearchParam({
      key: routeParam.SEARCH_VALUE,
      value: searchValue,
    })

    if ((visitSearchValue.length && searchValue === '') || searchValue.length >= 3) {
      const options = {
        visitsMode,
        fromDate,
        toDate,
        Offset: PAGINATION_INITIAL[0],
        Count: COUNT_STEP,
        searchValue,
        visitTypesFilterRow,
        statusFilterRow,
        tagFilterRow,
      }

      searchTitle.current = searchValue ?? ''
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getVisits(options))
      setVisitSearchValue(searchValue)
    }
  }

  const onSearch = debounce(onChangeSearchInput, 500)

  const onCloseChangeStatusPopup = () => {
    dispatch(changeVisitStatus({}))
  }

  const onCancelVisit = (reasonId: string, comment?: string) => {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    dispatch(cancelVisitFromVisitsPage(changeVisitStatusData.visitId, reasonId, comment))
  }

  const cancelTargetVisit = visitsList?.find(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (visit) => visit.VisitId === changeVisitStatusData.visitId,
  )
  const isCancelTargetReviewed = isAsynchronousVisitMethod(cancelTargetVisit?.Method)

  let noResults = ''
  if (loading) {
    noResults = ''
  } else if (
    visitSearchValue ||
    visitTypesFilterRow ||
    statusFilterRow ||
    tagFilterRow ||
    stateFilter?.date?.isDateUpdated
  ) {
    noResults = 'No visits to display'
  } else {
    noResults = 'No visits for this day to display'
  }

  return (
    <>
      {isOpenResolvePopup ?
        <ResolveVisitPopUp close={onCloseChangeStatusPopup} visitId={changeVisitStatusData.visitId} />
      : null}
      {isOpenCancelPopup ?
        <CancelVisitPopup
          closeAction={onCloseChangeStatusPopup}
          cancelAction={onCancelVisit}
          isReviewed={isCancelTargetReviewed}
        />
      : null}
      <section className={classNames('visits-container', { 'visits-has-results': visitsList?.length })}>
        {loading ?
          <PageLoadingSpinner />
        : null}
        {error || stateFilter.error ?
          <div>
            {/* eslint-disable @typescript-eslint/prefer-nullish-coalescing -- empty local error should fall through to the state error */}
            {/*
             // @ts-expect-error TS2741 -- MIGRATION: not approved, fix when encountered */}
            <ErrorAlert errorText={error || stateFilter.error} errorImg={errorIcon} imgAlt='Error' />
            {/* eslint-enable @typescript-eslint/prefer-nullish-coalescing -- re-enable after the intentional logical-or above */}
          </div>
        : null}
        <header className='visits-header'>
          <span className='visits-title'>{VISITS_LABEL}</span>
          <section className='visits-actions-section'>
            <div className='visits-search-section'>
              <VisitsListener fetchVisits={fetchVisits} />
              <Search
                isWithoutSearchDropdown
                onInputChange={onSearch}
                searchToolContainerClassName='visits-search-tool-container'
                defaultSearchValue={defaultVisitSearchValue}
                forceUpdate={isReloadSection}
              />
            </div>
            <Dropdown
              options={tableViewOptions}
              onSelectCallback={closeRemarks}
              isWithoutLabel
              containerStyle={selectVisitTypeDropdownContainerStyle}
              customIconStyles={selectVisitTypeDropdownIconStyle}
              inputStyle={selectVisitTypeDropdownInputStyle}
              dropdownContainerStyle={selectVisitTypeDropdownListContainerStyle}
              value={visitsMode}
              setValue={onChangeTableView}
              dropId='ViewDropDown'
              label=''
            />
          </section>
        </header>
        <section className={classNames('visits-table-wrap', { 'visits-table-wrap-data': totalCount })}>
          <VisitsTable
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            setTriggerTabId={setTriggerTabId}
            setSelectedVisitId={setSelectedVisitId}
            visitTypesFilterRow={visitTypesFilterRow}
            statusFilterRow={statusFilterRow}
            visitsMode={visitsMode}
            setStatusFilterRow={setStatusFilterRow}
            tagFilterRow={tagFilterRow}
            setStatusTagRow={setStatusTagRow}
            showRemarks={showRemarks}
            setShowRemarks={setShowRemarks}
            visits={visitsList}
            noResults={noResults}
            stateFilter={stateFilter}
            dispatchFilter={dispatchFilter}
            setVisitTypesFilterRow={setVisitTypesFilterRow}
            isNeedToUpdateFilterIcon={isPopstateChanges || isReloadSection}
          />
        </section>
        {!loading && totalCount ?
          <Pagination
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            className='visits-pagination'
            leftCount={paginationState[0]}
            rightCount={paginationState[1]}
            totalCount={totalCount}
            leftArrowAction={paginationLeft}
            rightArrowAction={paginationRight}
          />
        : null}
      </section>
    </>
  )
}

export default Visits
